import { globals } from '../../globals'
import moment from 'moment'
// ------------------------------------
// Constants
// ------------------------------------
export const GET_PERSONAL_NOTE_START = 'GET_PERSONAL_NOTE_START'
export const GET_PERSONAL_NOTE_SUCCESS = 'GET_PERSONAL_NOTE_SUCCESS'
export const GET_PERSONAL_NOTE_FAILED = 'NEW_FAVORITE_FAILED'
export const CREATE_PERSONAL_NOTE_START = 'CREATE_PERSONAL_NOTE_START'
export const CREATE_PERSONAL_NOTE_SUCCESS = 'CREATE_PERSONAL_NOTE_SUCCESS'
export const CREATE_PERSONAL_NOTE_FAILED = 'CREATE_PERSONAL_NOTE_FAILED'
export const UPDATE_PERSONAL_NOTE_START = 'UPDATE_PERSONAL_NOTE_START'
export const UPDATE_PERSONAL_NOTE_SUCCESS = 'UPDATE_PERSONAL_NOTE_SUCCESS'
export const UPDATE_PERSONAL_NOTE_FAILED = 'UPDATE_PERSONAL_NOTE_FAILED'
export const DELETE_PERSONAL_NOTE_START = 'DELETE_PERSONAL_NOTE_START'
export const DELETE_PERSONAL_NOTE_SUCCESS = 'DELETE_PERSONAL_NOTE_SUCCESS'
export const DELETE_PERSONAL_NOTE_FAILED = 'DELETE_PERSONAL_NOTE_FAILED'
export const THERE_ARE_NO_NOTES = 'THERE_ARE_NO_NOTES'
export const UPDATE_NOTES = 'UPDATE_NOTES'

// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  getPersonalNote,
  createPersonalNote,
  updatePersonalNote,
  deletePersonalNote,
}

export function updateNote (location, fieldValue) {
  return {
    type: UPDATE_NOTES,
    location,
    payload: {
      value: fieldValue,
    }
  }
}

export function getPersonalNote (usage, itemId) {
  return (dispatch) => {
    dispatch({ type: GET_PERSONAL_NOTE_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'GET',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/api/personalnotes?usage=${usage}&itemid=${itemId}`, options).then((response) => {
      if (response.status === 404) {
        dispatch({ type: THERE_ARE_NO_NOTES })
      } else if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_PERSONAL_NOTE_SUCCESS,
          payload: {
            json,
            itemId,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_PERSONAL_NOTE_FAILED })
    })
  }
}

export function createPersonalNote (personal) {
  return (dispatch) => {
    dispatch({ type: CREATE_PERSONAL_NOTE_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(personal)
    }
    fetch(`${globals.apiUrl}/api/personalnotes`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: CREATE_PERSONAL_NOTE_SUCCESS,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: CREATE_PERSONAL_NOTE_FAILED })
    })
  }
}

export function updatePersonalNote (personal) {
  return (dispatch) => {
    dispatch({ type: UPDATE_PERSONAL_NOTE_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify(personal)
    }
    fetch(`${globals.apiUrl}/api/personalnotes`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: UPDATE_PERSONAL_NOTE_SUCCESS,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: UPDATE_PERSONAL_NOTE_FAILED })
    })
  }
}

export function deletePersonalNote (usage, itemId) {
  return (dispatch) => {
    dispatch({ type: DELETE_PERSONAL_NOTE_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/api/personalnotes?usage=${usage}&itemid=${itemId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: DELETE_PERSONAL_NOTE_SUCCESS,
          payload: {
            json,
            itemId,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_PERSONAL_NOTE_FAILED })
    })
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_NOTES] : (state, action) => {
    const { value } = action.payload
    const { field } = action.location
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
      },
      formDataValue: {
        ...state.formDataValue,
        Bill: {
          ...state.formDataValue.Bill,
          [field]: {
            ...state.formDataValue.Bill[field],
            Note: value,
          }
        }
      }
    }
  },
  [GET_PERSONAL_NOTE_SUCCESS] : (state, action) => {
    const { json, itemId } = action.payload
    const date = json.NoteDate.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/g)[0]
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        noteCreated: undefined,
        noteFetched: json,
      },
      formDataValue: {
        ...state.formDataValue,
        Bill: {
          ...state.formDataValue.Bill,
          [itemId]: {
            Note: json.Note,
            NoteDate: moment(date).format('MM/DD/YYYY')
          },
        }
      }
    }
  },
  [CREATE_PERSONAL_NOTE_START] : (state) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        noteCreated: undefined,
      },
      formDataValue: {
        ...state.formDataValue,
      },
    }
  },
  [CREATE_PERSONAL_NOTE_SUCCESS] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        noteCreated: json,
      },
      formDataValue: {
        ...state.formDataValue,
      },
    }
  },
  [DELETE_PERSONAL_NOTE_SUCCESS] : (state, action) => {
    const { json, itemId } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        noteDeleted: json,
      },
      formDataValue: {
        ...state.formDataValue,
        Bill: {
          ...state.formDataValue.Bill,
          [itemId]: {
            ItemId: undefined,
            Note: undefined,
            NoteDate: undefined,
          },
        }
      }
    }
  },
  [UPDATE_PERSONAL_NOTE_SUCCESS] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        noteCreated: json,
      },
      formDataValue: {
        ...state.formDataValue,
      },
    }
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {},
  formDataValue: {
    Bill: {},
  },
}
export default function personalNotesReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/personalNotes.js